import { Link } from "react-router-dom";

export type NotFoundProps = {
  title?: string;
};

/** A page that was never bound in. */
export function NotFound({ title = "This page isn't in the book" }: NotFoundProps) {
  return (
    <div className="mx-auto max-w-md py-10 text-center">
      <section className="sheet grain-strong relative px-6 py-10">
        <svg
          viewBox="0 0 96 96"
          aria-hidden="true"
          className="mx-auto mb-6 h-24 w-24 opacity-80"
          fill="none"
          strokeWidth="1.5"
        >
          <rect x="16" y="10" width="64" height="76" fill="var(--color-card)" stroke="var(--color-rule)" />
          {/* A torn-out page. */}
          <path
            d="M26 22h44M26 32h44M26 42h30"
            stroke="var(--color-rule)"
            strokeDasharray="3 4"
          />
          <path
            d="M24 54c6 3 10-3 16 0s10-3 16 0 10-3 16 0v34H24V54Z"
            fill="var(--color-paper-deep)"
            stroke="var(--color-rule)"
          />
        </svg>

        <p className="field-label text-ink-soft">Missing plate</p>
        <h1 className="mt-3 display-3 text-3xl leading-tight text-ink">
          {title}
        </h1>
        <p className="mx-auto mt-3 max-w-prose font-prose leading-relaxed text-ink-soft">
          Either it was never bound in, or the page has been taken out. The scrapbook itself is
          perfectly intact.
        </p>
        <Link
          to="/scrapbook"
          className="touch mt-6 inline-flex items-center border border-ink bg-card px-4 py-2.5 font-label text-sm tracking-wide text-ink transition-colors hover:bg-paper-deep"
        >
          Back to the scrapbook
        </Link>
      </section>
    </div>
  );
}
